import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface QuestionsState {
  questionsList: any | null;
}

export const initialState: QuestionsState = {
  questionsList: null,
};

const medicalQuestionsPageSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {
    setQuestionsList(state, action: PayloadAction<any>) {
      state.questionsList = action.payload;
    },
  },
});

export const { setQuestionsList } = medicalQuestionsPageSlice.actions;
export default medicalQuestionsPageSlice.reducer;
